import Axios from "axios";
import { baseUrl } from "../../../config/url-config/index";
import { getDataLogin } from "../../../utils/getDataLogin";

const Post = (path, data) => {
  const promise = new Promise((resolve, reject) => {
    const config = {
      headers: { Authorization: `Bearer ${getDataLogin()?.token}` },
    };
    Axios.post(`${baseUrl}/${path}`, data, config).then(
      (result) => {
        resolve(result);
      },
      (err) => {
        reject(err);
      }
    );
  });
  return promise;
};

export default Post;
